var map = {
	"./brand/brand-shape-1.png": 70085,
	"./brand/brand-shape-2.png": 99726,
	"./brand/brand-shape-3.png": 45303,
	"./chrome.png": 89646,
	"./flags.png": 88195,
	"./logo-bigpicture-poweredby-negative.svg": 8160,
	"./logo-bigpicture-poweredby.svg": 38416,
	"./logo-bigpicture-storybook.svg": 79179,
	"./logo-bigpicture-text.png": 58642,
	"./logo-bigpicture-text.svg": 46024,
	"./map-pattern-a.png": 6311,
	"./map-pattern-b.png": 86252,
	"./menicon/conjunctival-hyperemia-0.jpg": 76300,
	"./menicon/conjunctival-hyperemia-1.jpg": 90441,
	"./menicon/conjunctival-hyperemia-2.jpg": 98942,
	"./menicon/conjunctival-hyperemia-3.jpg": 19099,
	"./menicon/conjunctival-hyperemia-4.jpg": 14216,
	"./menicon/corneal-infiltrates-0.jpg": 72919,
	"./menicon/corneal-infiltrates-1.jpg": 78458,
	"./menicon/corneal-infiltrates-2.jpg": 84709,
	"./menicon/corneal-infiltrates-3.jpg": 38696,
	"./menicon/corneal-infiltrates-4.jpg": 45019,
	"./menicon/corneal-neovascularisation-0.jpg": 52352,
	"./menicon/corneal-neovascularisation-1.jpg": 77917,
	"./menicon/corneal-neovascularisation-2.jpg": 58962,
	"./menicon/corneal-neovascularisation-3.jpg": 35343,
	"./menicon/corneal-neovascularisation-4.jpg": 70231,
	"./menicon/corneal-staining-0.jpg": 83165,
	"./menicon/corneal-staining-1.jpg": 27584,
	"./menicon/corneal-staining-2.jpg": 41199,
	"./menicon/corneal-staining-3.jpg": 73266,
	"./menicon/corneal-staining-4.jpg": 41281,
	"./menicon/lens-collection-contact-lens-coverage.jpg": 3370,
	"./menicon/papillary-reaction-0.jpg": 32151,
	"./menicon/papillary-reaction-1.jpg": 21338,
	"./menicon/papillary-reaction-2.jpg": 43941,
	"./menicon/papillary-reaction-3.jpg": 81576,
	"./menicon/papillary-reaction-4.jpg": 4251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95626;